import { getLocaleFromLocalStorage } from 'utils/intl-wrapper';
const locale = getLocaleFromLocalStorage();

export const IBAN_LENGTH = {
  EG: '24 ~ 29',
  SA: '24 ~ 29'
};

export const IBAN_PLACEHOLDER = {
  EG: `settings.payment_method.bank_details_modal.place_holder.iban`,
  SA: `settings.payment_method.bank_details_modal.place_holder_ksa.iban`
};

export const BANK_LIST = {
  EG: [
    {
      value: 'AAIB - البنك العربى الافريقى الدولى',
      label: 'AAIB - البنك العربى الافريقى الدولى'
    },
    {
      value: 'ABC - بنك المؤسسة العربية المصرفية – مصر',
      label: 'ABC - بنك المؤسسة العربية المصرفية – مصر'
    },
    {
      value: 'ABK - بنك الأهلي الكويتي - مصر',
      label: 'ABK - بنك الأهلي الكويتي - مصر'
    },
    { value: 'ABRK - بنك البركة - مصر', label: 'ABRK - بنك البركة - مصر' },
    {
      value: 'ADCB - بنك ابو ظبي التجاري',
      label: 'ADCB - بنك ابو ظبي التجاري'
    },
    {
      value: 'ADIB - مصرف أبو ظبي الإسلامي',
      label: 'ADIB - مصرف أبو ظبي الإسلامي'
    },
    {
      value: 'AIB - بنك الإستثمار العربي',
      label: 'AIB - بنك الإستثمار العربي'
    },
    { value: 'ARAB - البنك العربى', label: 'ARAB - البنك العربى' },
    {
      value: 'ARIB - المصرف العربي الدولي',
      label: 'ARIB - المصرف العربي الدولي'
    },
    { value: 'AUB - البنك الأهلي المتحد', label: 'AUB - البنك الأهلي المتحد' },
    { value: 'AUDI - بنك عودة', label: 'AUDI - بنك عودة' },
    { value: 'AWB - التجاري وفا بنك', label: 'AWB - التجاري وفا بنك' },
    { value: 'BBE - بنك باركليز', label: 'BBE - بنك باركليز' },
    { value: 'BDC - بنك القاهرة', label: 'BDC - بنك القاهرة' },
    { value: 'BLOM - بنك بلوم - مصر', label: 'BLOM - بنك بلوم - مصر' },
    { value: 'BOA - بنك الأسكندرية', label: 'BOA - بنك الأسكندرية' },
    {
      value: 'CAE - بنك كريدي أجريكول مصر',
      label: 'CAE - بنك كريدي أجريكول مصر'
    },
    {
      value: 'CBE - البنك المركزي المصري',
      label: 'CBE - البنك المركزي المصري'
    },
    {
      value: 'CIB - البنك التجاري الدولي',
      label: 'CIB - البنك التجاري الدولي'
    },
    {
      value: 'EDBE - البنك المصرى لتنمية الصادرات',
      label: 'EDBE - البنك المصرى لتنمية الصادرات'
    },
    {
      value: 'EGB - البنك المصرى الخليجى',
      label: 'EGB - البنك المصرى الخليجى'
    },
    {
      value: 'ENBD - بنك الإمارات دبي الوطنى',
      label: 'ENBD - بنك الإمارات دبي الوطنى'
    },
    {
      value: 'FAIB - بنك فيصل الإسلامى المصرى',
      label: 'FAIB - بنك فيصل الإسلامى المصرى'
    },
    {
      value: 'HDB - بنك التعمير والإسكان',
      label: 'HDB - بنك التعمير والإسكان'
    },
    {
      value: 'HSBC - بنك اتش اس بى سى مصر',
      label: 'HSBC - بنك اتش اس بى سى مصر'
    },
    { value: 'MASH - بنك المشرق', label: 'MASH - بنك المشرق' },
    { value: 'MIDB - بنك مصر ايران', label: 'MIDB - بنك مصر ايران' },
    { value: 'MISR - بنك مصر', label: 'MISR - بنك مصر' },
    { value: 'NBAD - بنك أبو ظبى الوطنى', label: 'NBAD - بنك أبو ظبى الوطنى' },
    { value: 'NBE - البنك الأهلى المصرى', label: 'NBE - البنك الأهلى المصرى' },
    {
      value: 'NBG - البنك الأهلي اليوناني - مصر',
      label: 'NBG - البنك الأهلي اليوناني - مصر'
    },
    {
      value: 'NBK - بنك الكويت الوطنى - مصر',
      label: 'NBK - بنك الكويت الوطنى - مصر'
    },
    {
      value: 'PDAC - البنك الرئيسي للتنمية والإئتمان الزراعي',
      label: 'PDAC - البنك الرئيسي للتنمية والإئتمان الزراعي'
    },
    {
      value: 'QNB - بنك قطر الوطنى الأهلى',
      label: 'QNB - بنك قطر الوطنى الأهلى'
    },
    {
      value: 'SAIB - بنك الشركة العربية المصرفية الدولية',
      label: 'SAIB - بنك الشركة العربية المصرفية الدولية'
    },
    { value: 'SCB - بنك قناة السويس', label: 'SCB - بنك قناة السويس' },
    { value: 'UB - المصرف المتحد', label: 'UB - المصرف المتحد' }
  ],
  SA: [
    {
      value: 'Saudi_National_Bank',
      label:
        locale === 'en' ? 'The Saudi National Bank' : 'البنك الأهلي السعودي'
    },
    {
      value: 'Alrajhi Bank',
      label: locale === 'en' ? 'Alrajhi Bank' : 'مصرف الراجحي'
    },
    {
      value: 'Alinma Bank',
      label: locale === 'en' ? 'Alinma Bank' : 'مصرف الانماء'
    },
    {
      value: 'Samba Bank',
      label: locale === 'en' ? 'Samba Bank' : 'مجموعة سامبا المالية'
    },
    {
      value: 'Aljazira Bank',
      label: locale === 'en' ? 'Aljazira Bank' : 'بنك الجزيرة'
    },
    {
      value: 'Albilad Bank',
      label: locale === 'en' ? 'Albilad Bank' : 'بنك البلاد'
    },
    {
      value: 'Riyad Bank',
      label: locale === 'en' ? 'Riyad Bank' : 'بنك الرياض'
    },
    {
      value: 'The Saudi British Bank - SABB',
      label:
        locale === 'en'
          ? 'The Saudi British Bank - SABB'
          : 'البنك السعودي البريطاني (ساب)'
    },
    {
      value: 'Banque Saudi Fransi',
      label: locale === 'en' ? 'Banque Saudi Fransi' : 'البنك السعودي الفرنسي'
    },
    {
      value: 'Alawwal Bank',
      label: locale === 'en' ? 'Alawwal Bank' : 'البنك الاول'
    },
    {
      value: 'The Saudi Investement bank',
      label:
        locale === 'en'
          ? 'The Saudi Investement bank'
          : 'البنك السعودي للأستثمار'
    },
    {
      value: 'The Arab National Bank',
      label: locale === 'en' ? 'The Arab National Bank' : 'البنك العربي الوطني'
    },
    {
      value: 'Gulf International Bank',
      label: locale === 'en' ? 'Gulf International Bank' : 'بنك الخليج الدولي'
    },
    {
      value: 'Banque Misr',
      label: locale === 'en' ? 'Banque Misr' : 'بنك مصر'
    },
    {
      value: 'Emirates NBD',
      label: locale === 'en' ? 'Emirates NBD' : 'بنك الامارات دبي الوطني'
    },
    {
      value: 'Trade Bank of Iraq ',
      label: locale === 'en' ? 'Trade Bank of Iraq' : 'المصرف العراقي للتجارة'
    },
    {
      value: 'First Abu Dhabi Bank',
      label: locale === 'en' ? 'First Abu Dhabi Bank' : 'بنك ابو ظبي الاول'
    },
    {
      value: 'MUFG Bank',
      label: locale === 'en' ? 'MUFG Bank' : 'بنك إم يو أف جي'
    },
    {
      value: 'Qatar National Bank',
      label: locale === 'en' ? 'Qatar National Bank' : 'بنك قطر الوطني (QNB)'
    },
    {
      value: 'National Bank of Bahrain',
      label: locale === 'en' ? 'National Bank of Bahrain' : 'بنك البحرين الوطني'
    },
    {
      value: 'The National Bank of Kuwait',
      label:
        locale === 'en' ? 'The National Bank of Kuwait' : 'بنك الكويت الوطني'
    },
    {
      value: 'Bank Muscat',
      label: locale === 'en' ? 'Bank Muscat' : 'بنك مسقط'
    },
    {
      value: 'Deutsche Bank AG',
      label: locale === 'en' ? 'Deutsche Bank AG' : 'دويتشه بنك'
    },
    {
      value: 'BNP Paribas S.A',
      label: locale === 'en' ? 'BNP Paribas S.A' : 'بي ان بي باريبا'
    },
    {
      value: 'JPMorgan Chase & Co.',
      label: locale === 'en' ? 'JPMorgan Chase & Co.' : 'جي بي مورغان تشيس'
    },
    {
      value: 'Industrial and Commercial Bank of China',
      label:
        locale === 'en'
          ? 'Industrial and Commercial Bank of China'
          : 'البنك الصناعي والتجاري الصيني'
    },
    {
      value: 'Standard Chartered',
      label: locale === 'en' ? 'Standard Chartered' : 'ستاندرد تشارترد'
    },
    {
      value: 'Credit Suisse',
      label: locale === 'en' ? 'Credit Suisse' : 'كريدت سويس العربية السعودية'
    },
    {
      value: 'National Bank of Pakistan',
      label:
        locale === 'en'
          ? 'National Bank of Pakistan'
          : 'البنك الوطني الباكستاني'
    }
  ]
};
